<template>
    <div class="landing-page">
        <div class="banner-container">
            <div class="banner-content">
                <div class="banner-text">
                    <div class="sub-title">专业裂变营销解决方案提供商</div>
                    <h1 class="main-title">助力企业实现<span style="color:#93C5FD;">指数级增长</span>的裂变营销平台</h1>
                    <p class="description">
                        珠海泰梦科技有限公司专注于为企业定制开发高效裂变营销平台，通过社交传播、用户裂变、数据驱动的方式，帮助品牌快速获取精准用户，提升营销ROI
                    </p>
                </div>
            </div>
        </div>
        <div class="core-business">
            <div class="container">
                <h2 class="section-title">核心业务</h2>
                <p class="section-subtitle">裂变营销平台代开发服务</p>
                <p class="section-desc">我们提供从需求分析到系统部署的全流程开发服务，打造符合企业特性的专属裂变营销工具</p>
                <div class="business-cards">
                    <div class="row">
                        <div class="col-md-4 business-card">
                            <div class="card-icon">
                                <div class="icon-circle">
                                    <i class="icon"><svg t="1767077323423" class="icon" viewBox="0 0 1072 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1974" width="200" height="200"><path d="M894.518 664.888c-68.635 0-124.721 36.712-150.81 93.733l-331.73-141.067a195.394 195.394 0 0 0 29.998-106.338c0-16.402-1.927-32.86-5.835-48.326l211.796-164.295c28.072 21.245 63.847 33.849 103.476 33.849 95.772 0 167.324-71.553 167.324-166.222C918.737 71.498 847.184 0 751.414 0S585.08 71.498 585.08 166.222c0 24.163 4.844 46.399 12.605 65.718L402.292 381.705c-38.638-57.957-102.485-98.522-175.029-98.522A214.107 214.107 0 0 0 12.603 496.74v0.935a214.107 214.107 0 0 0 214.66 214.548c44.528 0 86.084-11.559 119.988-32.805l380.99 162.37c4.844 89.826 74.471 156.535 166.277 156.535 95.772 0 166.334-71.553 166.334-166.222 0-94.724-71.553-167.212-166.278-167.212z" fill="#2563EB" p-id="1975"></path></svg></i>
                                </div>
                            </div>
                            <h3 class="card-title">社交裂变系统</h3>
                            <p class="card-desc">
                                基于社交关系网的裂变传播机制，支持拼团、分销、砍价等多种裂变玩法，实现用户指数级增长
                            </p>
                            <div class="mt-5">
                                <div class="btn-learn-more">了解更多→</div>
                            </div>
                        </div>
                        
                        <div class="col-md-4 business-card">
                            <div class="card-icon">
                                <div class="icon-circle">
                                    <i class="icon"><svg t="1767077377186" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3984" width="200" height="200"><path d="M912.955077 882.786462a37.139692 37.139692 0 0 1-74.279385 0v-0.433231h-1.063384a294.754462 294.754462 0 0 0-285.538462-255.035077c-3.190154 0.118154-6.301538 0.472615-9.531077 0.472615s-6.321231-0.354462-9.491692-0.472615a294.754462 294.754462 0 0 0-285.341539 255.035077h-0.905846v0.433231a37.139692 37.139692 0 0 1-74.279384 0l-0.33477-3.387077a35.446154 35.446154 0 0 1 2.678154-13.410462A365.449846 365.449846 0 0 1 395.815385 583.384615a253.164308 253.164308 0 0 1-113.644308-210.530461A257.732923 257.732923 0 0 1 542.641231 117.937231a257.732923 257.732923 0 0 1 260.430769 254.916923 253.164308 253.164308 0 0 1-113.565538 210.471384 365.312 365.312 0 0 1 221.518769 286.129231 35.268923 35.268923 0 0 1 1.595077 9.944616zM728.615385 372.932923a186.072615 186.072615 0 0 0-372.04677 0 186.072615 186.072615 0 0 0 372.04677 0z" fill="#2563EB" p-id="3985"></path></svg></i>
                                </div>
                            </div>
                            <h3 class="card-title">用户增长体系</h3>
                            <p class="card-desc">
                                构建完整的用户获取、激活、留存、转化体系，通过积分、等级、任务等激励机制提升用户活跃度
                            </p>
                                        
                            <div class="mt-5">
                                <div class="btn-learn-more">了解更多→</div>
                            </div>
                        </div>
                        <div class="col-md-4 business-card">
                            <div class="card-icon">
                                <div class="icon-circle">
                                    <i class="icon"><svg t="1767077431518" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5222" width="200" height="200"><path d="M138.545152 765.825024l95.52896 0c16.662528 0 30.16704-13.50656 30.16704-30.164992L264.241152 309.9648c0-16.662528-13.50656-30.16704-30.16704-30.16704L138.545152 279.79776c-16.662528 0-30.16704 13.50656-30.16704 30.16704l0 425.693184C108.376064 752.318464 121.882624 765.825024 138.545152 765.825024z" fill="#2563EB" p-id="5223"></path><path d="M445.435904 765.825024l95.52896 0c16.662528 0 30.16704-19.744768 30.16704-44.10368L571.131904 99.325952c0-24.36096-13.50656-44.107776-30.16704-44.107776l-95.52896 0c-16.66048 0-30.16704 19.746816-30.16704 44.107776l0 622.395392C415.268864 746.080256 428.773376 765.825024 445.435904 765.825024z" fill="#2563EB" p-id="5224"></path><path d="M752.326656 765.825024l95.52896 0c16.662528 0 30.16704-18.345984 30.16704-40.986624l0-578.3552c0-22.636544-13.50656-40.984576-30.16704-40.984576l-95.52896 0c-16.662528 0-30.16704 18.348032-30.16704 40.984576l0 578.3552C722.157568 747.476992 735.664128 765.825024 752.326656 765.825024z" fill="#2563EB" p-id="5225"></path><path d="M6.144 816.103424l968.704 0 0 50.2784-968.704 0 0-50.2784Z" fill="#2563EB" p-id="5226"></path></svg></i>
                                </div>
                            </div>
                            <h3 class="card-title">数据驱动营销</h3>
                            <p class="card-desc">
                                全链路数据洞察与分析，实时监控裂变效果，通过A/B测试优化营销策略，提升转化效率
                            </p>
                            <div class="mt-5">
                                <div class="btn-learn-more">了解更多→</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="development-process">
            <div class="container">
                <h2 class="section-title">标准化流程</h2>
                <p class="section-subtitle">高效透明的开发流程</p>
                <p class="section-desc">我们采用敏捷开发方法论，确保项目按时交付、质量可控，让您全程参与开发过程</p>
                
                <div class="process-steps">
                    <div class="row justify-content-center">
                        <div class="col-md-2 process-step">
                            <div class="step-circle">1</div>
                            <div class="step-content">
                                <h4 class="step-title">需求分析</h4>
                            </div>
                        </div>
                        <div class="col-md-2 process-step">
                            <div class="step-circle">2</div>
                            <div class="step-content">
                                <h4 class="step-title">方案设计</h4>
                            </div>
                        </div>
                        <div class="col-md-2 process-step">
                            <div class="step-circle">3</div>
                            <div class="step-content">
                                <h4 class="step-title">原型开发</h4>
                            </div>
                        </div>
                        <div class="col-md-2 process-step">
                            <div class="step-circle">4</div>
                            <div class="step-content">
                                <h4 class="step-title">系统开发</h4>
                            </div>
                        </div>
                        <div class="col-md-2 process-step">
                            <div class="step-circle">5</div>
                            <div class="step-content">
                                <h4 class="step-title">测试上线</h4>
                            </div>
                        </div>
                        <div class="col-md-2 process-step">
                            <div class="step-circle">6</div>
                            <div class="step-content">
                                <h4 class="step-title">运维支持</h4>
                            </div>
                        </div>
                        <div class="line"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="success-cases">
            <div class="container">
                <h2 class="section-title">成功案例</h2>
                <p class="section-subtitle">我们帮助这些企业实现了增长</p>
                <p class="section-desc">来自不同行业的客户通过我们的裂变营销平台，获得了显著的业务增长</p>
                
                <div class="case-cards">
                    <div class="related-cases">
                        <div class="case-card" @click="gotoRecruit">
                            <img src="../assets/case1.jpg" alt="教育行业案例" class="case-img">
                            <div class="case-info">
                                <div class="case-tag">教育行业</div>
                                <h3 class="case-title">在线教育平台分销裂变系统</h3>
                                <div class="case-stats">
                                    <div class="stat-item">
                                        <div class="stat-value">500+</div>
                                        <div class="stat-label">分销用户</div>
                                    </div>
                                    <div class="stat-item">
                                        <div class="stat-value">250万</div>
                                        <div class="stat-label">销售额</div>
                                    </div>
                                </div>
                                <div class="mt-5">
                                    <div class="btn-learn-more">查看完整案例→</div>
                                </div>
                            </div>
                        </div>
                        <div class="case-card" @click="gotoRecruit">
                            <img src="../assets/case2.jpg" alt="零售行业案例" class="case-img">
                            <div class="case-info">
                                <div class="case-tag">零售行业</div>
                                <h3 class="case-title">连锁零售品牌会员裂变系统</h3>
                                <div class="case-stats">
                                    <div class="stat-item">
                                        <div class="stat-value">220%</div>
                                        <div class="stat-label">会员增长</div>
                                    </div>
                                    <div class="stat-item">
                                        <div class="stat-value">150%</div>
                                        <div class="stat-label">复购提升</div>
                                    </div>
                                </div>
                                <div class="mt-5">
                                    <div class="btn-learn-more">查看完整案例→</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        gotoRecruit() {
            this.$router.push({
                name: 'recruit'
            })
        }
    }
}
</script>

<style type="text/css" lang="scss">
.landing-page {
    color: #333;
    background-color: #fff;
    .banner-container {
        background: linear-gradient(135deg, #1E3A8A 0%, #1F4ED9 100%);
        color: white;
        padding: 100px 0;
        margin-bottom: 80px;
        position: relative;
        overflow: hidden;
        &::before {
            content: '';
            position: absolute;
            width: 400px;
            height: 400px;
            border-radius: 50%;
            background: #6366F1;
            left: -200px;
            bottom: -350px;
            transform: translateY(-50%);
            z-index: 1;
        }
        
        &::after {
            content: '';
            position: absolute;
            width: 400px;
            height: 400px;
            border-radius: 50%;
            background: #3B82F6;
            right: -180px;
            top: 0;
            transform: translateY(-50%);
            z-index: 1;
        }
        
        .banner-content {
            margin: 0 auto;
            padding: 0 20px;
            position: relative;
            z-index: 2;
            
            .banner-text {
                position: relative;
                z-index: 3; 
                display: flex;
                flex-direction: column;
                align-items: center;
                .sub-title {
                    font-size: 18px;
                    font-weight: 500;
                    margin-bottom: 20px;
                    opacity: 0.9;
                    color:#E5E7EB;
                }
                
                .main-title {
                    font-size: 48px;
                    font-weight: 700;
                    line-height: 1.2;
                    margin-bottom: 30px;
                    color: #FFFFFF;
                }
                
                .description {
                    max-width: 800px;
                    font-size: 20px;
                    line-height: 1.6;
                    opacity: 0.9;
                    color: #E5E7EB;
                    text-align: center;
                }
            }
        }
    }
    
    .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
    }
    
    .section-title {
        font-size: 16px;
        font-weight: 700;
        color: #3B82F6;
        text-align: center;
        margin-bottom: 20px;
    }
    
    .section-subtitle {
        font-size: 24px;
        font-weight: 600;
        color: #333;
        text-align: center;
        margin-bottom: 15px;
    }
    
    .section-desc {
        font-size: 16px;
        color: #666;
        text-align: center;
        max-width: 700px;
        margin: 0 auto 50px;
        line-height: 1.6;
    }
    
    .core-business {
        padding: 80px 0;
        text-align: start;
        background-color: #fff;
        .business-cards {
            margin-top: 50px;
            
            .business-card {
                padding: 40px 30px;
                transition: transform 0.3s ease;
                border: 1px solid #F1F5F9;
                box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
                border-radius: 10px;
                &:hover {
                    transform: translateY(-10px);
                    
                    .icon-circle {
                        background: #DBEAFE;
                    }
                }
                .card-icon {
                    margin-bottom: 30px;
                    .icon-circle {
                        width: 60px;
                        height: 60px;
                        border-radius: 12px;
                        background: #DBEAFE;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transition: background 0.3s ease;
                        
                        .icon {
                            font-size: 30px;
                            width: 30px;
                        }
                    }
                }
                
                .card-title {
                    font-size: 24px;
                    font-weight: 600;
                    color: #1e3c72;
                    margin-bottom: 20px;
                }
                
                .card-desc {
                    font-size: 16px;
                    color: #666;
                    line-height: 1.6;
                }
            }
        }
        
    }
    .btn-learn-more {
        color: #3B82F6;
        font-size: 18px;
        font-weight: 600;
    }
    
    .development-process {
        padding: 80px 0;
        .process-steps {
            margin-top: 60px;
            position: relative;
            .process-step {
                text-align: center;
                padding: 0 15px;
                
                .step-circle {
                    width: 70px;
                    height: 70px;
                    border-radius: 50%;
                    background: #2563EB;
                    color: white;
                    font-size: 28px;
                    font-weight: 700;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 20px;
                    position: relative;
                    z-index: 2;
                }
                
                .step-content {
                    .step-title {
                        font-size: 18px;
                        font-weight: 600;
                        color: #333;
                        margin-bottom: 8px;
                    }
                    
                    .step-desc {
                        font-size: 14px;
                        color: #666;
                    }
                }
            }
            .line {
                position: absolute;
                bottom: 60px;
                left: 0;
                right: 0;
                height: 4px;
                width: 100%;
                background: #BFDBFE;
            }
        }
    }
    
    .success-cases {
        padding: 80px 0;
        text-align: start;
        .case-cards {
            margin-top: 50px;
            .related-cases {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 20px;
                
                .case-card {
                    overflow: hidden;
                    border-radius: 8px;
                    padding-bottom: 20px;
                    border: 1px solid #e2e8f0;
                    transition: transform 0.3s ease;
                    &:hover {
                        transform: translateY(-10px);
                    }
                    .case-img {
                        width: 100%;
                        height: 250px;
                        object-fit: cover;
                    }
                    .case-info {
                        padding: 20px;
                    }
                    .case-tag {
                        color: #2563EB;
                        font-size: 12px;
                        padding-bottom: 10px;
                    }
                    
                    .case-title {
                        font-size: 16px;
                        font-weight: 600;
                        color: #1a1a1a;
                    }
                    
                    .case-stats {
                        display: flex;
                        padding: 0 10px 10px 10px;
                        gap: 80px;
                        
                        .stat-item {
                            .stat-value {
                                font-size: 16px;
                                font-weight: 700;
                                color: #000;
                            }
                            
                            .stat-label {
                                font-size: 12px;
                                color: #666;
                            }
                        }
                    }
                }
            }
        }
    }
    @media (max-width: 992px) {
        .banner-container {
            padding: 60px 0;
            
            .banner-content {
                .banner-text {
                    .main-title {
                        font-size: 36px;
                    }
                    
                    .description {
                        font-size: 16px;
                    }
                }
            }
        }
        
        .section-title {
            font-size: 30px;
        }
        
        .section-subtitle {
            font-size: 20px;
        }
        
        .business-card {
            margin-bottom: 40px;
        }
        
        .process-step {
            margin-bottom: 30px;
        }
    }
    
    @media (max-width: 768px) {
        .banner-container {
            .banner-content {
                .banner-text {
                    .main-title {
                        font-size: 28px;
                    }
                    
                    .sub-title {
                        font-size: 18px;
                    }
                }
            }
        }
        
        .section-title {
            font-size: 26px;
        }
        
        .section-subtitle {
            font-size: 18px;
        }
        
        .case-card {
            margin-bottom: 30px;
        }
    }
}
.row {
    gap: 20px;
    flex-wrap: nowrap !important;
}
</style>